import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

export const CardBand = ({
  className,
  ...props
}: React.ComponentProps<typeof Stack>) => (
  <Stack
    direction="row"
    gap={2}
    align="center"
    className={cn(
      "w-full bg-surface-sunken px-4 py-2 text-subtle [&_svg]:size-4 [&_svg]:shrink-0",
      className,
    )}
    {...props}
  />
);
